import {Box, styled} from '@mui/material';

const StyledBox = styled(Box)`
	margin-top: -16px;
	margin-bottom: 12px;
	padding: 0px 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 0px 24px;
	}
`;

export {StyledBox};
